import { SVGProps } from "react";
import styles from "../variants/01/sw-categories-variant-01.module.scss";

export const CategoryPicapeSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 747.9 284.7"
    style={{
      // @ts-ignore
      enableBackground: "new 0 0 747.9 284.7",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{".st0{fill:#2f333e}"}</style>
    <path
      className={styles.st0}
      d="M159.7 181.9c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9-41.9-18.8-41.9-41.9 18.8-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.3-60.9-60.9-60.9zM630.3 181.9c23.1 0 41.9 18.8 41.9 41.9s-18.8 41.9-41.9 41.9c-23.1 0-41.9-18.8-41.9-41.9s18.8-41.9 41.9-41.9m0-19c-33.6 0-60.9 27.3-60.9 60.9s27.3 60.9 60.9 60.9 60.9-27.3 60.9-60.9-27.3-60.9-60.9-60.9z"
    />
    <path
      className={styles.st0}
      d="M747.7 175.6c-.1-.3-2.8-6.7-10.1-7.9V119c0-1-.1-6.3-6.5-13-13.4-14.3-51.1-31.2-154.5-31.3C568.1 66.6 497.3 0 464.9 0H336.1c-1.5-.1-9.7.4-12.5 16.3-.5 3.2-1.1 7.9-1.8 13.5-1.3 10.8-3 24.2-5.5 35.1-3.8 16.6-7.5 17.5-8.2 17.5H30.4c-.2 0-21.2 2-21.2 23.8v59.7c-1.8.1-4 .6-5.9 2.1-2.2 1.7-3.3 4.4-3.3 8v33.4c.1.7 2.8 16.9 36.6 16.9h44v-5c1.3-42.4 36.2-76.5 79-76.5 42.7 0 77.7 34.1 79 76.5v5h312.6v-5c1.3-42.4 36.2-76.5 79-76.5s77.7 34.1 79 76.5v5h22.2l.3-.1c5.5-1.5 16-8.1 16-22.1v-28.5zm-4.8 28.5c0 12.6-10.2 16.6-12.1 17.2h-16.5c-1.3-45.2-38.5-81.5-84-81.5s-82.7 36.4-84 81.5H243.7c-1.3-45.2-38.5-81.5-84-81.5s-82.7 36.4-84 81.5h-39C9 221.3 5.3 210.1 5 208.9V176c0-2 .5-3.5 1.5-4.3 1.5-1.2 3.9-1.1 4.7-.9l3 .6v-65.3c0-16.7 15.1-18.6 16.5-18.8h277.5c10.7 0 14.8-25.8 18.6-57 .7-5.5 1.2-10.2 1.8-13.2C330.3 7.5 334 5 335.8 5h129C496.5 5 573 78.2 573.7 79l.7.7h1c106.8 0 140.8 18.3 151.5 29.3 2.8 2.8 4.2 5.3 4.8 7s.7 2.8.7 2.8v53.6h2.5c4.9 0 7.1 3.5 7.8 4.6v27.1z"
    />
    <path
      className={styles.st0}
      d="m375.5 14.9 7.8 71.3h-32c-3.9 0-6.9-3.4-6.6-7.3l6-58.6c.3-3.1 2.9-5.5 6.1-5.5h18.7zM516.8 86.2h-112l-12.4-71.3h50.4c12.8 0 25.5 2.5 37.2 7.4 9.8 4 18.7 9.9 26.5 17.1l32 29.3c0-.1-34.7-2.7-21.7 17.5z"
    />
  </svg>
);
